import { post, get, put, del } from '../axios'

export const getUpcomingAuctions = () => {
  return get('/api/auction/website/homepage/upcoming-auctions')
}

export const getTrendingLots = () => {
  return get('/api/lot/website/homepage/trending-lots')
}

export const searchAndFilterTrendingLots = (sortBy, category, artName, yearFrom, yearTo, priceLow, priceHigh, keyword, size = 10, page = 1) => {
  const params = new URLSearchParams()
  params.append('sortBy', sortBy)
  const categories = Array.isArray(category) ? category : [category];
  categories.filter(Boolean).forEach(item => {
    params.append('categories', item);
  });
  const artNames = Array.isArray(artName) ? artName : [artName];
  artNames.filter(Boolean).forEach(item => {
    params.append('artistNames', item);
  });

  if (yearFrom) {
    params.append('yearFrom', yearFrom);
  }

  if (yearTo) {
    params.append('yearTo', yearTo);
  }

  if (priceLow) {
    params.append('priceLow', priceLow);
  }

  if (priceHigh) {
    params.append('priceHigh', priceHigh);
  }

  if (keyword) {
    params.append('keyword', keyword);
  }
  params.append('size', size);
  params.append('page', page);
  return get(`/api/lot/website/search/lot-infos?${params.toString()}`)
}

export const getLotsFilterCategory = () => {
  return get(`/api/lot/website/lots/category/tree`)
}

export const getLotsArtNames = () => {
  return get(`/api/lot/website/lots/artist/name-list`)
}

export const getUpcomingAuctionCategory = (status = "upcoming") => {
  return get(`/api/auction/website/auctions/categories?status=${status}`)
}

export const getUpcomingAuctionCity = (status = "upcoming") => {
  return get(`/api/auction/website/auctions/cities?status=${status}`)
}

export const searchAndFilterUpcomingAuctions = (sortBy, cities, categories, dateFrom, dateTo, keyword, size = 10, page = 1) => {
  const params = new URLSearchParams()
  params.append('sortBy', sortBy)
  const _categories = Array.isArray(categories) ? categories : [categories];
  _categories.filter(Boolean).forEach(item => {
    params.append('categories', item);
  });
  const _cities = Array.isArray(cities) ? cities : [cities];
  _cities.filter(Boolean).forEach(item => {
    params.append('cities', item);
  });

  if (dateFrom) {
    params.append('dateFrom', dateFrom);
  }

  if (dateTo) {
    params.append('dateTo', dateTo);
  }

  if (keyword) {
    params.append('keyword', keyword);
  }
  params.append('size', size);
  params.append('page', page);
  return get(`/api/auction/website/search/auction-calender?${params.toString()}`)
}

export const searchAndFilterClosedAuctions = (cities, categories, dateFrom, dateTo, keyword, size = 10, page = 1) => {
  const params = new URLSearchParams()
  const _categories = Array.isArray(categories) ? categories : [categories];
  _categories.filter(Boolean).forEach(item => {
    params.append('categories', item);
  });
  const _cities = Array.isArray(cities) ? cities : [cities];
  _cities.filter(Boolean).forEach(item => {
    params.append('cities', item);
  });

  if (dateFrom) {
    params.append('dateFrom', dateFrom);
  }

  if (dateTo) {
    params.append('dateTo', dateTo);
  }

  if (keyword) {
    params.append('keyword', keyword);
  }
  params.append('size', size);
  params.append('page', page);
  return get(`/api/auction/website/search/auction-results?${params.toString()}`)
}

export const getLotDetailById = id => {
  return get(`/api/lot/website/lots/${id}/detail`)
}

export const getAuctionDetailById = id => {
  return get(`/api/auction/website/auctions/${id}/detail`)
}

export const getBanner = () => {
  return get(`/api/content/website/homepage/slider-items`)
}

export const getAuctionLotsByid = (auctionId, sortBy, category, artName, yearFrom, yearTo, priceLow, priceHigh, keyword, size = 10, page = 1) => {
  const params = new URLSearchParams()
  params.append('sortBy', sortBy)
  const categories = Array.isArray(category) ? category : [category];
  categories.filter(Boolean).forEach(item => {
    params.append('categories', item);
  });
  const artNames = Array.isArray(artName) ? artName : [artName];
  artNames.filter(Boolean).forEach(item => {
    params.append('artistNames', item);
  });

  if (yearFrom) {
    params.append('yearFrom', yearFrom);
  }

  if (yearTo) {
    params.append('yearTo', yearTo);
  }

  if (priceLow) {
    params.append('priceLow', priceLow);
  }

  if (priceHigh) {
    params.append('priceHigh', priceHigh);
  }

  if (keyword) {
    params.append('keyword', keyword);
  }
  params.append('size', size);
  params.append('page', page);
  return get(`/api/lot/website/search/auction/${auctionId}/lot-infos?${params.toString()}`)
}

export const getRelatedLots = (lotId, auctionld) => {
  const params = new URLSearchParams()
  params.append('auctionId', auctionld);
  return get(`/api/lot/website/lots/${lotId}/related-lots?${params.toString()}`)
}

export const getNewsList = (category, keyword, size = 10, page = 1) => {
  const params = new URLSearchParams()
  const categories = Array.isArray(category) ? category : [category];
  categories.filter(Boolean).forEach(item => {
    params.append('categories', item);
  });
  if (keyword) {
    params.append('keyword', keyword);
  }
  params.append('size', size);
  params.append('page', page);
  return get(`/api/content/website/search/news?${params.toString()}`)
}

export const getRecentPost = (count = 5) => {
  const params = new URLSearchParams()
  params.append('count', count);
  return get(`/api/content/website/news/recent-posts?${params.toString()}`)
}

export const getNewsDetail = id => {
  return get(`/api/content/website/articles/${id}/details`)
}

export const getAboutUs = id => {
  return get(`/api/content/website/page/about-us`)
}

export const getContactUsInfo = () => {
  return get(`/api/content/website/page/contact-us`)
}

export const getHomeArtist = () => {
  return get(`/api/content/website/homepage/slider-artists`)
}